const docType = {
  'application/msword': 'doc',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'docx',
  'image/jpg': 'jpg',
  'image/jpeg': 'jpg',
  'application/pdf': 'pdf',
  'image/png': 'png'
}

export const parseFileExtension = (name: string, type: string) => {
  const ext = name.split('.').pop()
  if (ext) {
    return ext
  }

  if (docType[type]) {
    return docType[type]
  }

  return 'pdf'
}
